/**
 * DodoMarket for Business — Corporate Gifting Landing Page JS
 * Loaded only on page.corporate-gifting template
 */

(function() {
  'use strict';

  /* Reveal on scroll. Runs FIRST and uses a plain loop: .d4b-rv starts at opacity:0, so if
     anything below this throws, the sections are already revealed rather than left invisible.
     Browsers without IntersectionObserver skip the animation and show everything immediately. */
  var revealables = document.querySelectorAll('.d4b-rv');
  var i;
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      for (var j = 0; j < entries.length; j++) {
        if (entries[j].isIntersecting) entries[j].target.classList.add('d4b-vis');
      }
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
    for (i = 0; i < revealables.length; i++) { obs.observe(revealables[i]); }
  } else {
    for (i = 0; i < revealables.length; i++) { revealables[i].classList.add('d4b-vis'); }
  }

  /* FAQ toggle — one open at a time, with aria-expanded sync */
  document.querySelectorAll('.d4b-fi-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.d4b-fi');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.d4b-fi').forEach(function(x) {
        x.classList.remove('open');
        var b = x.querySelector('.d4b-fi-q');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* Sticky CTA bar + mobile pill (show after scrolling past hero) */
  var sbar = document.getElementById('d4b-sbar');
  var mpill = document.getElementById('d4b-mob-pill');
  var hero = document.querySelector('.d4b-hero');
  if (hero) {
    var shown = false;
    function onScroll() {
      var heroH = hero.offsetHeight;
      var y = window.scrollY || window.pageYOffset;
      if (y > heroH && !shown) {
        shown = true;
        if (sbar) sbar.classList.add('d4b-show');
        if (mpill) mpill.classList.add('d4b-show');
      } else if (y <= heroH && shown) {
        shown = false;
        if (sbar) sbar.classList.remove('d4b-show');
        if (mpill) mpill.classList.remove('d4b-show');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Booking ("Book a Free Intro Call"): each link keeps a real cal.com href as the fallback.
     Cal's embed opens the in-page modal on click but does NOT cancel a real link's navigation
     (its own examples use href="javascript:void(0)"). So we preventDefault — but ONLY once the
     external embed.js has actually loaded (window.__d4bCalReady, set on the script's load event
     in d4b-cal-embed.liquid). If the embed is slow, blocked, or fails, the flag stays false and
     the click falls through to the real href (hosted Cal page) — so the CTA never dead-ends. */
  document.querySelectorAll('a[data-cal-link]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      if (window.__d4bCalReady) { e.preventDefault(); }
    });
  });

  /* PDF catalogue — open the catalogue, and capture the lead to Attio in parallel.
     The reveal is OPTIMISTIC and never waits on Attio (the webhook is async and its CORS is
     locked to its own app origin, so the browser can't read a real result anyway). The PDF is
     opened SYNCHRONOUSLY inside the submit gesture so the browser treats it as user-initiated
     and doesn't block the tab; if a popup blocker still stops it, we show a direct download
     link. The lead is posted fire-and-forget as application/x-www-form-urlencoded — the one
     CORS-safelisted content-type Attio accepts (it rejects text/plain) — so there's no preflight
     and the request is actually sent. No secret is exposed: the endpoint is a public, no-secret
     Attio inbound URL set in theme settings; a WhatsApp/email fallback is always shown. */
  var pdfForm = document.getElementById('d4b-pdf-form');
  if (pdfForm) {
    var pdfStatus = document.getElementById('d4b-pdf-status');

    function d4bQ(name) {
      var m = new RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
      return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : '';
    }
    function d4bForm(obj) {
      var parts = [];
      for (var k in obj) {
        if (obj.hasOwnProperty(k)) { parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(obj[k])); }
      }
      return parts.join('&');
    }
    function d4bStatus(html, kind) {
      if (!pdfStatus) return;
      pdfStatus.className = 'd4b-pdf-status' + (kind ? ' is-' + kind : '');
      pdfStatus.innerHTML = html;
    }
    function d4bFallback() {
      var wa = pdfForm.getAttribute('data-wa-url');
      var email = pdfForm.getAttribute('data-email');
      var bits = [];
      if (wa) { bits.push('<a href="' + wa + '" target="_blank" rel="noopener">WhatsApp us</a>'); }
      if (email) { bits.push('<a href="mailto:' + email + '">' + email + '</a>'); }
      return bits.length ? ' Trouble downloading? ' + bits.join(' or ') + '.' : '';
    }
    /* Open within the user gesture; returns true on success, false if the popup was blocked. */
    function d4bOpenPdf() {
      var url = pdfForm.getAttribute('data-pdf-url');
      if (!url) { return true; }
      var w = window.open(url, '_blank');
      if (w) { try { w.opener = null; } catch (e) {} return true; }
      return false;
    }
    function d4bSendLead(body, url) {
      if (window.fetch) {
        fetch(url, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }, body: body })['catch'](function () {});
      } else {
        try {
          var xhr = new XMLHttpRequest();
          xhr.open('POST', url, true);
          xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
          xhr.send(body);
        } catch (err) {}
      }
    }

    pdfForm.addEventListener('submit', function(e) {
      e.preventDefault();

      /* Honeypot — bots fill the hidden field, humans never do */
      var hp = pdfForm.querySelector('input[name="website"]');
      if (hp && hp.value) { return; }

      var emailInput = pdfForm.querySelector('input[type="email"]');
      var email = emailInput ? emailInput.value.replace(/^\s+|\s+$/g, '') : '';
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        d4bStatus('Please enter a valid work email.', 'error');
        if (emailInput) { emailInput.focus(); }
        return;
      }

      /* Open the catalogue first, synchronously, so the browser counts it as user-initiated. */
      var opened = d4bOpenPdf();

      /* Capture the lead to Attio in parallel — fire-and-forget; never gates the reveal. */
      var attioUrl = pdfForm.getAttribute('data-attio-url');
      if (attioUrl) {
        d4bSendLead(d4bForm({
          email: email,
          lead_source: 'corporate-gifting-landing',
          lead_intent: 'pdf_catalogue',
          catalogue_version: pdfForm.getAttribute('data-catalogue-version') || '',
          landing_page_url: window.location.href,
          utm_source: d4bQ('utm_source'),
          utm_medium: d4bQ('utm_medium'),
          utm_campaign: d4bQ('utm_campaign'),
          utm_content: d4bQ('utm_content'),
          utm_term: d4bQ('utm_term'),
          /* Honeypot — empty for real users; sent so an Attio Condition can also drop non-empty. */
          website: hp ? hp.value : ''
        }), attioUrl);
      }

      if (opened) {
        d4bStatus('Thanks! Your catalogue is opening in a new tab.' + d4bFallback(), 'success');
      } else {
        var pdfUrl = pdfForm.getAttribute('data-pdf-url');
        d4bStatus('Your catalogue is ready &mdash; <a href="' + pdfUrl + '" target="_blank" rel="noopener">open the PDF</a>.' + d4bFallback(), 'success');
      }
    });
  }
})();
